import pluralize from 'pluralize'
import slidesSelector from './slides'

const modalSelector = (state, modalId) => {
  let modal = state.modals[modalId]

  const contentId = modal.modalContentId
  const contentType = pluralize(modal.modalContentType)

  modal.content = state[contentType][contentId]

  if (contentType === 'slideshows') {
    modal.content.slides = slidesSelector(state, modal.content.slides)
  }

  return modal
}

export default modalSelector



// WEBPACK FOOTER //
// ./src/selectors/modal.js